window.SwymCallbacks = window.SwymCallbacks || [];

window.SwymCallbacks.push(function (swat) {
  if (!window.SwymWishlistSync) {
    return;
  }

  window.SwymWishlistSync.init(swat, function () {
    window.SwymWishlistSync.refreshButtons(true);
  });

  window.SwymWishlistSync.refreshButtons(true);

  document.addEventListener('swym:collections-loaded', function () {
    window.setTimeout(function () {
      window.SwymWishlistSync.refreshButtons(true);
    }, 250);
  });
});
